<template>
	<div class="servicos" aria-label="Serviços">
		<div class="wrap-content">
			<div>
				<img src="../assets/icons/burger.svg" alt="artesanal" />
				<div>
					<h1 class="title">Artesanal</h1>
					<p class="description">Nossas receitas são feitas com todo cuidado</p>
				</div>
			</div>
			<div>
				<img src="../assets/icons/headset.svg" alt="atendimento" />
				<div>
					<h1 class="title">Atendimento</h1>
					<p class="description">Totalmente personalizado</p>
				</div>
			</div>
			<div>
				<img src="../assets/icons/delivery.svg" alt="delivery" />
				<div>
					<h1 class="title">Delivery Speed</h1>
					<p class="description">Entregamos menos de 45 minutos</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ServicosBox'
};
</script>

<style></style>
